import styled from "styled-components";

import { LARGE_SCREEN } from "../../constants/screenSizes";
import { typographyWeights } from "../constants/fontWeightOptions";
import { baseTextStyles } from "../shared/styled";

export const PrimarySmallBase = styled.h3`
  ${baseTextStyles}
  font-size: 28px;
  font-weight: ${props => typographyWeights[props.weight]};
  line-height: 36px;

  @media screen and (max-width: ${LARGE_SCREEN}px) {
    font-size: 24px;
    line-height: 34px;
  }
`;
